module.exports = __webpack_public_path__ + "static/img/6.06014e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncq/6.png
// module id = 9FIV
// module chunks = 1